export const styles = {
  wrapper: {
    minHeight: '100px',
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/LiveMap/styled.js